import * as moment from "moment";

import { AccountSubTypeEnum, ReportReferredAccountsColumnNames } from "@spa/api";

import {
    ComponentTypesEnum,
    UnspecifiedKeysEnum,
} from "../../../app/shared/enums";
import {
    ReportTableColumn,
    ReportTableConfigInterface,
} from "../../../app/shared/components";
import { FilterControlInterface } from "../../../app/shared/interfaces";
import {
    AutocompleteControl,
    DatepickerControl,
} from "../../../app/shared/classes";
import { Validators } from "@angular/forms";

/** Referrals cover margin and hard-BP trading accounts, and the backend filters on this list of sub-types. */
export const ReferredAccountsTradingSubTypes = (): number[] => [AccountSubTypeEnum.Trading, AccountSubTypeEnum.TradingHardBp];

export const PanelReportsReferredAccountsFilterControls =
    (): FilterControlInterface[] => {
        return [
            {
                name: ReportReferredAccountsColumnNames.ReferralCode,
                placeholder: "Referral Code",
                controls: [
                    new AutocompleteControl({
                        name: ReportReferredAccountsColumnNames.ReferralCode,
                        value: null,
                        async: true,
                        placeholder: "Referral Code",
                        validators: [
                            Validators.required,
                            Validators.maxLength(100),
                        ],
                        componentType: ComponentTypesEnum.Autocomplete,
                        options: [],
                        grouped: false,
                    }),
                ],
                shown: true,
                sortIndex: 1,
            },
            {
                name: ReportReferredAccountsColumnNames.Date,
                placeholder: "Date",
                controls: [
                    new DatepickerControl({
                        name: ReportReferredAccountsColumnNames.FromDate,
                        value: null,
                        placeholder: "Date From",
                        maxDate: moment().format("YYYY-MM-DD"),
                        validators: [],
                        componentType: ComponentTypesEnum.Datepicker,
                    }),
                    new DatepickerControl({
                        name: ReportReferredAccountsColumnNames.ToDate,
                        value: null,
                        placeholder: "Date to",
                        maxDate: moment().format("YYYY-MM-DD"),
                        validators: [],
                        componentType: ComponentTypesEnum.Datepicker,
                    }),
                ],
                shown: true,
                sortIndex: 2,
            },
            {
                name: ReportReferredAccountsColumnNames.AccountReferenceId,
                placeholder: "Account",
                controls: [
                    new AutocompleteControl({
                        name: ReportReferredAccountsColumnNames.AccountReferenceId,
                        value: UnspecifiedKeysEnum.UnspecifiedAccountsKey,
                        placeholder: "Account",
                        async: true,
                        validators: [Validators.maxLength(100)],
                        componentType: ComponentTypesEnum.Autocomplete,
                        options: [
                            {
                                label: "All",
                                value: UnspecifiedKeysEnum.UnspecifiedAccountsKey,
                            },
                        ],
                        grouped: false,
                    }),
                ],
                shown: true,
                sortIndex: 3,
            },
        ];
    };

export const PanelReportsReferredAccountsDataTableConfig: ReportTableConfigInterface =
    {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: "REFERRAL",
                selector: ReportReferredAccountsColumnNames.ReferralCode,
            }),
            new ReportTableColumn({
                label: "ACCOUNT",
                selector: ReportReferredAccountsColumnNames.Account,
            }),
            new ReportTableColumn({
                label: "ORDERS",
                selector: ReportReferredAccountsColumnNames.Orders,
                shifted: true,
            }),
            new ReportTableColumn({
                label: "FILLS",
                selector: ReportReferredAccountsColumnNames.Fills,
                shifted: true,
            }),
            new ReportTableColumn({
                label: "QTY",
                selector: ReportReferredAccountsColumnNames.Quantity,
                shifted: true,
            }),
            new ReportTableColumn({
                label: "COMM",
                selector: ReportReferredAccountsColumnNames.Commission,
                shifted: true,
            }),
            new ReportTableColumn({
                label: "CCY",
                selector: ReportReferredAccountsColumnNames.Currency,
                shifted: true,
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true,
    };

